import { TrackingEventName } from '@/models/analytics/eventTypes';
import {
  trackChatContextAddFileClickedSpec,
  trackChatContextAddSessionClickedSpec,
  trackChatContextAttachPatientClickedSpec,
  trackChatCreatedSpec,
  trackChatDeletedSpec,
  trackChatMessageSentWithContextSpec,
  trackChatViewedSpec,
  trackFollowUpQuestionClickedSpec,
  trackMessageAbortedSpec,
  trackMessageFailedSpec,
  trackMessageReceivedSpec,
  trackMessageStoppedSpec,
  trackMessageSubmittedSpec,
  type ChatContextAddFileClicked,
  type ChatContextAddSessionClicked,
  type ChatContextAttachPatientClicked,
  type ChatCreated,
  type ChatDeleted,
  type ChatMessageSentWithContext,
  type ChatViewed,
  type FollowUpQuestionClicked,
  type MessageAborted,
  type MessageFailed,
  type MessageReceived,
  type MessageStopped,
  type MessageSubmitted,
} from '@snowtype/snowplow';
import type { SnowplowEventMap } from '../trackSnowplowEvent';

export const chatEvents: SnowplowEventMap = {
  [TrackingEventName.MessageSubmitted]: (props) =>
    trackMessageSubmittedSpec(props as MessageSubmitted),
  [TrackingEventName.MessageAborted]: (props) =>
    trackMessageAbortedSpec(props as MessageAborted),
  [TrackingEventName.MessageFailed]: (props) =>
    trackMessageFailedSpec(props as MessageFailed),
  [TrackingEventName.MessageReceived]: (props) =>
    trackMessageReceivedSpec(props as MessageReceived),
  [TrackingEventName.MessageStopped]: (props) =>
    trackMessageStoppedSpec(props as MessageStopped),
  [TrackingEventName.ChatCreated]: (props) => trackChatCreatedSpec(props as ChatCreated),
  [TrackingEventName.ChatDeleted]: (props) => trackChatDeletedSpec(props as ChatDeleted),
  [TrackingEventName.ChatViewed]: (props) => trackChatViewedSpec(props as ChatViewed),
  [TrackingEventName.ChatContextAddFileClicked]: (props) =>
    trackChatContextAddFileClickedSpec(props as ChatContextAddFileClicked),
  [TrackingEventName.ChatContextAddSessionClicked]: (props) =>
    trackChatContextAddSessionClickedSpec(props as ChatContextAddSessionClicked),
  [TrackingEventName.ChatContextAttachPatientClicked]: (props) =>
    trackChatContextAttachPatientClickedSpec(props as ChatContextAttachPatientClicked),
  [TrackingEventName.ChatMessageSentWithContext]: (props) =>
    trackChatMessageSentWithContextSpec(props as ChatMessageSentWithContext),
  [TrackingEventName.FollowUpQuestionClicked]: (props) =>
    trackFollowUpQuestionClickedSpec(props as FollowUpQuestionClicked),
};
